import React from "react";

class ErrorMsg extends React.Component {

    render() {
        return (
            
            <h3 className='error-message'>Please Enter a Problem!</h3>
            
        )
    }

}

export default ErrorMsg;
